import React from 'react';
import Box from "@mui/material/Box"

import { addDefaultSource, handleImgLoad } from '../../services/errorHandlers';
import { createImageUrl } from '../../services/data';

interface ImageWrapperProps {
    width?: string;
    height?: string;
    img: string;
    hasOverlay?: boolean;
    borderRadius?: string;
    aspectRatio?: string;
    objectFit?: React.CSSProperties['objectFit'];
    style?: React.CSSProperties;
    className?: string;
}

const ImageWrapper: React.FC<ImageWrapperProps> = ({ width = '100%', height = '100%', img, hasOverlay = false, borderRadius = '0', aspectRatio = 'initial', objectFit = 'cover' }) => {
    return (
        <Box
            sx={{
                height: height,
                width: width,
                position: 'relative',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column',
                borderRadius: 0,
                aspectRatio,
                p: 0,
                m: 0,
                img: {
                    objectFit: objectFit,
                    height: '100%',
                    width: '100%',
                    display: 'block',
                    margin: 0,
                    padding: 0,
                    borderRadius: 0,
                }
            }}
        >
            <img style={{ objectFit, height: '100%', width: '100%', display: 'block', margin: 0, padding: 0, borderRadius: 0 }} src={createImageUrl(img)} alt='exhibition_image' onError={addDefaultSource} onLoad={handleImgLoad} loading='lazy' />
            {hasOverlay && <div style={{ position: 'absolute', background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 68.56%, rgba(0, 0, 0, 0.90) 98.04%)', left: 0, bottom: 0, width: '100%', height: '100%', padding: 1 }} />}
        </Box>
    );
};

export default ImageWrapper;
